export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import type {SenderAttachment} from 'kpc';

interface Props {
    value?: string
    attachments?: SenderAttachment[]
    mediaType?: 'image' | 'video' | null
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            value: '',
            attachments: [],
            mediaType: 'image' as 'image' | 'video' | null,
        };
    }

    getUploadAccept() {
        return this.get('mediaType') === 'video' ? 'video/*' : 'image/*';
    }
}